import s from './MyInput.module.css';
import {GreenButton} from '../MyButton';

export function MyInput({inputLabel, myRef, dataInput, changeAction}) {	
	return (<div style={{margin:"0", display:"flex", alignItems:"center"}}>
		{
			(inputLabel!='') && (<div style={{margin:"0 10px 0 10px", fontSize:"22px", whiteSpace:"nowrap"}}>{inputLabel}</div>)
		}
		<input ref={myRef} className={s.inputBox} type="text" value={dataInput}  style={{margin:"0 10px 0 0"}}
			onChange={(e)=> {
				changeAction(e.target.value);
			}} />
	</div>)
}
